import Swiper from 'swiper/bundle';
// cssはCDNで読み込んでいる

// KVの画像スライダー
export const kvSlider = new Swiper('.kvSlider', {
	loop: true,
	effect: 'fade',
	direction: 'horizontal',
	slidesPerView: 1,
	slidesPerGroup: 1,
	allowTouchMove: false,
	speed: 2000,
	autoplay: {
		delay: 3000,
		disableOnInteraction: true,
	},
});

// カプセルスライダー
export const pointSlider = new Swiper('.pointSlider', {
	loop: true,
	// freeMode: true,
	grabCursor: true,
	direction: 'horizontal',
	// 480px以下の時(sp)
	slidesPerView: 3.5,
	slidesPerGroup: 1,
	speed: 3000,
	autoplay: true,
	spaceBetween: 10,
	pauseOnMouseEnter: true,
	// autoplayDisableOnInteraction: true,
	autoplay: {
		delay: 0,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	breakpoints: {
		// 480px以上の時(iPad)
		480: {
			slidesPerView: 5,
			slidesPerGroup: 1,
		},
		// 768px以上の時(pc)
		1024: {
			slidesPerView: 8.5,
			slidesPerGroup: 1,
			spaceBetween: 20,
		},
		// 2000px以上の時(pc)
		2000: {
			slidesPerView: 7,
			slidesPerGroup: 1,
		},
	},
});

// お客様の声のスライダー
export const voiceSlider = new Swiper('.voiceSlider', {
	loop: true,
	direction: 'horizontal',
	// 480px以下の時(sp)
	slidesPerView: 1,
	slidesPerGroup: 1,
	spaceBetween: 40,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		// 1024px以上の時(pc)
		1024: {
			slidesPerView: 3,
			slidesPerGroup: 3,
		},
		// 480px以上の時(iPad)
		480: {
			slidesPerView: 2,
			slidesPerGroup: 2,
		},
	},
});
